var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquiggleArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1135,
    height: 825,
    viewBox: "0 0 1135 825",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.701 194.393C148.697 140.909 311.682 169.9 326.181 252.377C352.979 393.936 169.695 435.657 74.7031 438.822C6.70914 331.653 63.7041 231.216 100.701 194.393ZM100.701 194.393C89.1019 -30.7412 380.966 -25.9914 420.673 43.937",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9912 194.944C99.9912 277.42 242.479 327.405 325.971 254.926",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0985 579.47C84.0922 424.015 458.059 427.014 479.557 682.44C584.548 514.989 930.517 597.965 946.016 787.409",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M465.959 525.374C529.787 499.548 666.741 487.285 703.938 644.839",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9935 438.732C79.1598 373.918 135.388 246.288 326.971 254.286",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.093 439.51C38.7629 446.675 -24.6982 484.098 12.0985 576.471C131.688 651.649 227.913 590.467 261.077 550.478",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M464.559 525.486C484.89 541.814 516.354 596.065 479.557 682.44",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M946.016 783.91C986.513 822.899 1079.8 868.286 1129 737.924",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.01 619.458C1048.51 660.946 1086.1 751.32 944.516 780.911",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M479.557 679.441C502.722 716.93 564.75 772.514 627.544 694.937M703.038 643.952C743.367 583.969 861.624 495.095 1012.01 619.459",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M703.038 645.45C712.37 703.434 773.131 812.002 941.516 782.411M466.058 525.485C435.061 422.515 149.086 330.442 15.0982 577.97",
    stroke: "#0E22F1",
    strokeOpacity: 0.6,
    strokeDasharray: "6 6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 431.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white",
    stroke: "#0B23F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 253.5,
    y: 542.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white",
    stroke: "#0B23F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 457.5,
    y: 517.5,
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "white",
    stroke: "#0B23F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 5.5,
    transform: "matrix(-1 0 0 1 105 187)",
    fill: "white",
    stroke: "#0B23F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 314.5,
    y: 241.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white",
    stroke: "#0B23F4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 416.5,
    y: 39.5002,
    width: 8,
    height: 8,
    rx: 4,
    fill: "white",
    stroke: "#0B23F4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 688.5,
    y: 629.5,
    width: 29,
    height: 29,
    rx: 14.5,
    fill: "white",
    stroke: "#0B23F4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1003.5,
    y: 609.5,
    width: 17,
    height: 17,
    rx: 8.5,
    fill: "white",
    stroke: "#0B23F4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1123.5,
    y: 731.5,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "white",
    stroke: "#0B23F4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 617.5,
    y: 682.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white",
    stroke: "#0B23F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquiggleArt);
export default __webpack_public_path__ + "static/media/squiggle-art.f7a1e14f0748f2170bafaf5ecede1866.svg";
export { ForwardRef as ReactComponent };